import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import CustomTypography from "../../globalStyles/fonts";
import { agentConfigService } from "../../utils/services/agentConfigService";

const AgentConfigModal = ({ open, handleClose, onAddData, selectedAgent }) => {
  const [details, setDetails] = useState({ name: "", id: "" });
  const [formErrors, setFormErrors] = useState({});

  const initialData = () => {
    setDetails({ name: "", id: "" });
    setFormErrors({});
  };

  const validateForm = () => {
    const errors = {};
    if (!details.name?.trim()) errors.name = "Agent name is required.";
    if (!details.id?.trim()) errors.id = "Agent ID is required.";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    if (selectedAgent) {
      setDetails({
        name: selectedAgent?.name || "",
        id: selectedAgent?.id || "",
      });
    } else {
      initialData();
    }
  }, [selectedAgent]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditData = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      const { name, id } = details;
      await agentConfigService.edit({ name, id }, selectedAgent._id);
      onAddData && onAddData();
      toast.success("Agent config updated successfully!");
      initialData();
      handleClose();
    } catch (err) {
      toast.error("Failed to update agent config.");
      console.error(err);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      await agentConfigService.create(details);
      onAddData && onAddData();
      toast.success("Agent config created successfully!");
      initialData();
      handleClose();
    } catch (err) {
      toast.error("Failed to create agent config.");
      console.error(err);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        initialData();
        handleClose();
      }}
      maxWidth="sm"
      fullWidth
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <DialogTitle
          style={{ fontFamily: "Poppins", fontSize: 24, fontWeight: 500 }}
        >
          {selectedAgent ? "Edit Agent Config" : "Create Agent Config"}
        </DialogTitle>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider style={{ marginBottom: 10 }} />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CustomTypography>Agent Name</CustomTypography>
            <TextField
              size="small"
              name="name"
              value={details.name}
              onChange={handleInputChange}
              fullWidth
              margin="dense"
              error={!!formErrors.name}
              helperText={formErrors.name}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTypography>Agent ID</CustomTypography>
            <TextField
              size="small"
              name="id"
              value={details.id}
              onChange={handleInputChange}
              fullWidth
              margin="dense"
              error={!!formErrors.id}
              helperText={formErrors.id}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ padding: 15 }}>
        <Button
          onClick={() => {
            handleClose();
            initialData();
          }}
          variant="outlined"
          style={{ fontFamily: "Poppins", fontSize: 14, fontWeight: 600 }}
        >
          Cancel
        </Button>
        <Button
          onClick={(e) => (selectedAgent ? handleEditData(e) : handleSave(e))}
          variant="contained"
          style={{ fontFamily: "Poppins", fontSize: 14, fontWeight: 600 }}
        >
          {selectedAgent ? "Save" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AgentConfigModal;
